<script>
    // @ts-nocheck
    import { InputText, Select, SelectX, TextArea, Row } from '../UI'
    import {
        validateDoc,
        validarCuit,
        validarCbu,
        validarTelefono,
        validateEmail,
    } from '$lib/utils'
    import dictionaries from '../../stores/dictionaries'
    export let data = {}
    export let inputs = null
    export let editable = true
    export const valid = true
    export let dynamic = true
    export let providerSiniestros = false
    $: allowedInputs = inputs instanceof Array ? inputs : []
    $: showAll = !(allowedInputs.length > 0)
    function allowInputs() {
        let args = Array.prototype.slice.call(arguments)
        return showAll || args.some((x) => allowedInputs.includes(x))
    }
    if (dynamic && data.no_doc_dp) {
        data.no_doc_ac = data.no_doc_dp
    }
    if (dynamic && data.tipo_doc_dp) {
        data.tipo_doc_ac = data.tipo_doc_dp
    }
    if (dynamic && data.tel_dp) {
        data.tel_ac = data.tel_dp
    }
    if (dynamic && data.domicilio_dp) {
        data.domicilio_ac = data.domicilio_dp
    }
    if (dynamic && data.cuit_ii) {
        data.cuit_ac = data.cuit_ii
    }
</script>

{#if allowInputs('banco_ac')}
    <SelectX
        required
        options={$dictionaries.bancos}
        bind:value={data.banco_ac}
        name="banco_ac"
        disabled={!editable}
        label="Banco"
    />
{/if}
{#if allowInputs('cbu_ac')}
    <InputText
        required
        disabled={!editable}
        name="cbu_ac"
        maxLength={22}
        bind:value={data.cbu_ac}
        errorMsg="El CBU no pertenece al banco informado."
        info="El CBU debe contener 22 dígitos numéricos y debe pertenecer al banco seleccionado."
        validation={(n) =>
            typeof n === 'string' &&
            n.match(/[0-9]+/) &&
            validarCbu(n, data.banco_ac)}
        label="C.B.U"
    />
{/if}
{#if allowInputs('titular_ac')}
    <InputText
        maxLength={70}
        required
        disabled={!editable}
        name="titular_ac"
        label="Titular"
        bind:value={data.titular_ac}
    />
{/if}
{#if allowInputs('cuit_ac')}
    <InputText
        required
        disabled={!editable}
        errorMsg="Ingrese un CUIT válido."
        info="El CUIT debe contener 11 dígitos numéricos."
        maxLength={11}
        validation={(n) => typeof n === 'string' && validarCuit(n)}
        name="cuit_ac"
        bind:value={data.cuit_ac}
        label="CUIT N°"
    />
{/if}
{#if allowInputs('domicilio_ac')}
    <InputText
        maxLength={100}
        required
        disabled={!editable}
        bind:value={data.domicilio_ac}
        name="domicilio_ac"
        label="Domicilio"
    />
{/if}
{#if allowInputs('tel_ac', 'fax_ac')}
    <Row>
        {#if allowInputs('tel_ac')}
            <InputText
                required
                disabled={!editable}
                maxLength={18}
                errorMsg="Ingrese un Teléfono válido."
                info="El Teléfono debe cumplir con el formato 011122336544."
                name="tel_ac"
                bind:value={data.tel_ac}
                label="Teléfono"
                validation={validarTelefono}
            />
        {/if}
        {#if allowInputs('fax_ac')}
            <InputText
                maxLength={18}
                errorMsg="Ingrese un Fax válido."
                info="El Fax debe cumplir con el formato 011122336544."
                name="fax_ac"
                disabled={!editable}
                bind:value={data.fax_ac}
                label="Fax"
                validation={validarTelefono}
            />
        {/if}
    </Row>
{/if}
{#if allowInputs('email_ac')}
    <InputText
        required
        disabled={!editable}
        maxLength={256}
        validation={validateEmail}
        errorMsg="Escriba un email válido."
        bind:value={data.email_ac}
        name="email_ac"
        label="E-Mail"
    />
{/if}
{#if !providerSiniestros}
    {#if allowInputs('presentado_ac')}
        <InputText
            required
            name="presentado_ac"
            disabled={!editable}
            label="Presentado por"
            bind:value={data.presentado_ac}
        />
    {/if}
    {#if allowInputs('tipo_doc_ac', 'no_doc_ac')}
        <Row>
            {#if allowInputs('tipo_doc_ac')}
                {#key `${data.tipo_doc_dp}`}
                    <Select
                        required
                        disabled={!editable}
                        name="tipo_doc_ac"
                        label="Tipo Documento"
                        bind:value={data.tipo_doc_ac}
                        options={$dictionaries.tipo_documento}
                        placeholder="Seleccione una opción."
                    />
                {/key}
            {/if}
            {#if allowInputs('no_doc_ac')}
                {#key `${data.tipo_doc_ac}`}
                    <InputText
                        required
                        disabled={!editable}
                        maxLength={11}
                        bind:value={data.no_doc_ac}
                        errorMsg="Ingrese un Documento válido."
                        info="Ingrese un documento sin espacios ni puntos."
                        validation={validateDoc(data.tipo_doc_ac)}
                        name="no_doc_ac"
                        label="Documento"
                    />
                {/key}
            {/if}
        </Row>
    {/if}
{/if}
<TextArea
    name="observaciones_ac"
    disabled={!editable}
    label="Observaciones"
    bind:value={data.observaciones_ac}
/>
